
import Meteors from "../../components/magicui/meteors";
const FourBox = () => {
  return (
    
        <div className="bodybox relative pt-5 pb-5 overflow-x-clip    bg-orange-300 ">
            <Meteors number={50}  />
            <div className="container  sm:container   mx-auto ">
                <div className="headerlines   mx-auto md:mx-auto text-wrap  justify-center items-center ">
                    <h1 className="text-center text-4xl lg:text-6xl">
                        Error-Free GST Returns
                    </h1>
                </div>
                <div className="contentbox mt-5 mb-3 justify-center items-center text-center mx-auto">
                    <div className="grid lg:grid-cols-2 mx-auto justify-center items-center md:grid-cols-1  gap-10 sm:grid-cols-1    ">
                        <div className="justify-center mt-3  items-center"> 
                        <div className="relative flex text-xl  pt-4 pb-4 px-4  w-full   flex-col  justify-center overflow-hidden rounded-lg border bg-background md:shadow-xl">
                                <div className="headercontent mt-4">
                                    <h1 className="text-2xl lg:text-2xl">File GST Return  with CA Solution</h1>
                                </div>
                                <div className="paralines mt-3 mb-3">
                                    <ul className="lists mx-5 text-start text-xl">
                                        {/* <li className="mt-2">Largest Tax Filing Portal in India</li> */}
                                        <li className="mt-2">File Directly to GST Portal</li>
                                        <li className="mt-2">File Accurately </li>
                                        <li className="mt-2">File with full Confidentiality</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="justify-center mt-3  items-center"> 
                        <div className="relative flex text-xl  pt-4 pb-4 px-4  w-full   flex-col  justify-center overflow-hidden rounded-lg border bg-background md:shadow-xl">
                            <div className="headercontent mt-4">
                                    <h1 className="text-2xl lg:text-2xl">Completely Hassle-Free</h1>
                                </div>
                                <div className="paralines mt-3 mb-3">
                                    <ul className="lists mx-5 text-start text-xl">
                                        <li className="mt-2">Effortless Way to Be Compliant</li>
                                        {/* <li className="mt-2">Pay Minimum Possible Taxes</li> */}
                                        {/* <li className="mt-2">Get Maximum Refunds</li> */}
                                        <li className="mt-2">Error-Free GST Returns = Trouble-Free GST Refunds</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
  )
}

export default FourBox